import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { setMobiMemberForceLogoutHandler } from './api/memberRestApi'
import postNotify, { showPostNotify } from './plugins/postNotify'
import './assets/css/sourceSite/sourceSiteBundle.css'

Vue.config.productionTip = false
Vue.use(postNotify)

setMobiMemberForceLogoutHandler(async (msg) => {
  const text = String(msg || '').trim() || '登錄已失效，請重新登錄。'
  try {
    await showPostNotify({ type: 'warning', title: '登錄狀態', message: text })
  } catch (e) {
    void e
  }
  try {
    localStorage.removeItem('mobi_login_name')
    localStorage.removeItem('mobi_must_change_pwd')
  } catch (e) {
    void e
  }
  const n = router.currentRoute && router.currentRoute.name
  if (n === 'Login' || n === 'MobiLogin') return
  router.replace({ name: 'Login' }).catch(() => {})
})

new Vue({
  router,
  render: (h) => h(App)
}).$mount('#app')
